import React from 'react';
import useStyle from './commandeSingle.style';
import { CommandDetailLine } from 'components/atoms/Texts/CommandDetailLine';
import { ClientInput } from '../../graphql/generated/graphql';
import { firstCharToUpperCase } from 'helpers/text/firstCharToUpperCase';

interface LivraisonDetailProps {
  client: ClientInput;
}

const LivraisonDetail = ({ client }: LivraisonDetailProps) => {
  const classes = useStyle();
  if (!client)
    return (
      <p className={classes.redText}>
        Contactez votre professeur pour plus d'information
      </p>
    );
  return (
    <>
      {!client.livraisonhorslycee ? (
        <p className={classes.redText}>Livraison au lycée</p>
      ) : (
        <div>
          {client.affilie ? (
            <>
              <p className={classes.redText}>Livraison en point relais :</p>
              <CommandDetailLine
                withDivider={true}
                title="Nom du point relais"
                text={client.nompointrelais}
              />
              <CommandDetailLine
                withDivider={true}
                title="Adresse de livraison"
                text={client.adresselivraison}
              />
              <CommandDetailLine
                withDivider={true}
                title="Ville"
                text={client.villelivraison}
              />
              <CommandDetailLine
                title="Code postal"
                text={client.cplivraison}
              />
            </>
          ) : (
            <>
              <p className={classes.redText}>Livraison hors lycée :</p>
              <CommandDetailLine
                withDivider={true}
                title="Civilité"
                text={firstCharToUpperCase(client.civilitelivraison)}
              />
              <CommandDetailLine
                withDivider={true}
                title="Nom"
                text={client.nomlivraison}
              />
              <CommandDetailLine
                withDivider={true}
                title="Prénom"
                text={client.prenomlivraison}
              />
              <CommandDetailLine
                withDivider={true}
                title="Adresse de livraison"
                text={client.adresselivraison}
              />
              <CommandDetailLine
                withDivider={true}
                title="Ville"
                text={client.villelivraison}
              />
              <CommandDetailLine
                title="Code postal"
                text={client.cplivraison}
              />
            </>
          )}
        </div>
      )}
    </>
  );
};

export default LivraisonDetail;
